import React, { useContext } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import useSocietyClientService from '../../../app/services/hooks/useSocietyClientService';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';

interface Props {
    societyClientId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const ClientSwitchChange = ({ societyClientId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeSocietyClient, fetchingActiveSocietyClient } = useSocietyClientService();

    const active = (value: boolean) => {
        setChecked(value);

        activeSocietyClient(societyClientId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={societyClientId} callback={active} />;
};

export default ClientSwitchChange;
